export enum EnumPreferencesSection {
  Geral = 'geral',
  Conhecimento = 'conhecimento',
  Memorias = 'memorias',
  Habilidades = 'habilidades',
  Automacoes = 'automacoes',
  Conectores = 'conectores',
  Plugin = 'plugin',
}
